export const environment = process.env.NEXT_PUBLIC_APP_ENV as string ?? 'local';

export const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;
export const baseApiUrl = process.env.NEXT_PUBLIC_API_BASE_URL as string;
export const intakeLink = process.env.NEXT_PUBLIC_INTAKE_LINK as string;
export const datadogApplicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID as string;

export const appVersion = process.env.NEXT_PUBLIC_APP_VERSION as string;

export const auth0Domain = process.env.NEXT_PUBLIC_AUTH0_DOMAIN as string;
export const auth0ClientId = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID as string;
export const auth0Audience = process.env.NEXT_PUBLIC_AUTH0_AUDIENCE as string;

export const datadogService = process.env.NEXT_PUBLIC_DD_SERVICE as string;
export const datadogSite = process.env.NEXT_PUBLIC_DD_SITE as string;
export const datadogClientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN as string;
export const isDatadogEnabled = (process.env.NEXT_PUBLIC_DD_ENABLED as string) === 'true';
